export function InvoicePaymentsCtrl (
  $scope,
  $state,
  $translate,
  stripeApi,
  workshopAPI,
  workshopPayApi
) {
  $scope.showCustomerInvoicePayments = !!$scope.payments.length;
  $scope.workshopPayApi              = workshopPayApi;

  $scope.tableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'customer_payment_number',
        header : {
          text: $translate.instant('INVOICE_SPACE.PAYMENT_NO')
        }
      },
      {
        classes: 'text-left',
        field  : 'post_date',
        header : {
          text: $translate.instant('INVOICE_SPACE.PAYMENT_DATE')
        },
        pipe: 'globalDate'
      },
      {
        classes: 'text-left',
        field  : 'status',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'invoiceStatus'
      },
      {
        classes: 'text-right',
        field  : 'amount',
        header : {
          classes: 'text-right',
          text   : $translate.instant('GENERAL_SPACE.FIELD.PAYMENT_AMOUNT')
        },
        pipe: 'globalCurrency'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_PAYMENTS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/invoices/payment_count_for_invoice', $scope.invoice.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'post_date'
    },
  };

  $scope.collectStripePayment = function () {
    stripeApi.checkout($scope.invoice)
    .finally(() => {
      $state.reload();
    });
  };

  $scope.getPayments = ( params ) => {
    return workshopAPI.get('/invoices/payments_for_invoice_list', [
      $scope.invoice.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
    ]).then(payments => {
      $scope.payments = payments;

      return payments;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $state.go('app.customer-payment', {
      customer_id: event.row.customer_id,
      id         : event.row.id
    });
  };
}